import {
  MAX_CONVERSIONS_VALUE,
  MAX_CONVERSIONS_VALUE_SCHEMA,
} from './max-conversions-value';
import {
  MAX_CONVERSIONS,
  MAX_CONVERSIONS_SCHEMA,
} from './max-conversions';
import {
  MANUAL_CPA,
  MANUAL_CPA_SCHEMA,
} from './manual-cpa';
import {
  MANUAL_CPC,
  MANUAL_CPC_SCHEMA,
} from './manual-cpc';

export const BID_STRATEGY_SCHEMA_MAP = {
  [MAX_CONVERSIONS.type]: MAX_CONVERSIONS_SCHEMA,
  [MAX_CONVERSIONS_VALUE.type]: MAX_CONVERSIONS_VALUE_SCHEMA,
  [MANUAL_CPA.type]: MANUAL_CPA_SCHEMA,
  [MANUAL_CPC.type]: MANUAL_CPC_SCHEMA,
};

export const BID_STRATEGY_OPTIONS_MAP = {
  [MAX_CONVERSIONS.type]: MAX_CONVERSIONS,
  [MAX_CONVERSIONS_VALUE.type]: MAX_CONVERSIONS_VALUE,
  [MANUAL_CPA.type]: MANUAL_CPA,
  [MANUAL_CPC.type]: MANUAL_CPC,
};
